var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperPlus = function SvgPaperPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11V9h8v2H8Zm0 3v-2h8v2H8Zm0 3v-2h8v2H8Zm9-8V7h-2V5h2V3h2v2h2v2h-2v2h-2ZM3 21V3h11v2H5v14h14v-9h2v11H3Z",
    fill: "#191919"
  })));
};
export { SvgPaperPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTFWOUgxNlYxMUg4Wk04IDE0VjEySDE2VjE0SDhaTTggMTdWMTVIMTZWMTdIOFpNMTcgOVY3SDE1VjVIMTdWM0gxOVY1SDIxVjdIMTlWOUgxN1pNMyAyMVYzSDE0VjVINVYxOUgxOVYxMEgyMVYyMUgzWiIgZmlsbD0iIzE5MTkxOSIvPgo8L3N2Zz4K";